"use client";

import { selectIsUserLoggedIn, selectUser } from "stores/auth/authSlice";
import { useAppSelector } from "stores/hooks";
export const WelcomeUserText = ({
  className = ""
}: {
  className?: string;
}) => {
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  const user = useAppSelector(selectUser);
  if (!isLoggedIn || !user?.firstName) return null;
  return <span className={`hidden h-12 items-center whitespace-nowrap px-2 text-[11px] font-normal sm:flex lg:text-base lg:font-medium ${className}`} data-sentry-component="WelcomeUserText" data-sentry-source-file="WelcomeUserText.tsx">
      Welcome, {user.firstName}
    </span>;
};